// Authentication utilities

/**
 * Hash a password using SHA-256
 * @param {string} password - The password to hash
 * @returns {Promise<string>} - The hashed password
 */
export const hashPassword = async (password) => {
  // Convert password to Uint8Array
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  
  // Hash the password using SHA-256
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  
  // Convert hash to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  
  return hashHex;
};

/**
 * Verify a password against the stored hash
 * @param {string} password - The password to verify
 * @param {string} storedHash - The stored hash to compare against
 * @returns {Promise<boolean>} - True if password matches
 */
export const verifyPassword = async (password, storedHash) => {
  const hashedInput = await hashPassword(password);
  return hashedInput === storedHash;
};

/**
 * Get the admin password hash from environment variables
 * @returns {string} - The stored password hash
 */
export const getStoredPasswordHash = () => {
  const hash = process.env.REACT_APP_ADMIN_PASSWORD_HASH;

  // Debug logging
  console.log('Environment check:', {
    hash: hash ? 'Found' : 'Not found',
    allEnvVars: Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')),
    nodeEnv: process.env.NODE_ENV
  });

  if (!hash) {
    console.error('REACT_APP_ADMIN_PASSWORD_HASH not found in environment variables');
    console.error('Available REACT_APP_ variables:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));

    // Fallback hash for "myfinbrain2025" - remove this in production
    console.warn('Using fallback password hash for development');
    return 'bdd257e3ed69e7f986bf1758283203eb386761f615f3b0d5441866577d883917';
  }

  return hash;
};
